import {jwtServerInstance} from "../index";
import qs from	'qs'

export const getTaobaoGoodInfo = (dialogForm)=>{
    return jwtServerInstance.request({
        url:'/taskservice/getTaoGoodInfo',
        method:'post',
        data:qs.stringify({
            url:dialogForm.productUrl,
            shopId:dialogForm.shopInfo
        })
    });
}

export const getTaobaoAuthorUrl = ()=>{
    return jwtServerInstance.request({
        url:'/taskservice/getTaobaoautorurl',
        method:'post',
    });
}

export const getTaobaoAuthorInfo = (plateformUsername)=>{
    return jwtServerInstance.request({
        url:'/taskservice/queryauthinfo',
        method:'post',
        data: qs.stringify({
            plateformUsername: plateformUsername
        })
    });
}

export const addplateformflag = (tradeForm)=>{
    return jwtServerInstance.request({
        url:'/taskservice/addplateformflag',
        method:'post',
        data: qs.stringify({
            orderRemarks: tradeForm.tradeMemo,
            flag: tradeForm.tradeFlag,
            platefromOrderNum: tradeForm.platefromOrderNum,
            plateformAccountName: tradeForm.plateformAccountName
        })
    });
}

export const updateplateformflag = (tradeForm)=>{
    return jwtServerInstance.request({
        url:'/taskservice/updateplateformflag',
        method:'post',
        data: qs.stringify({
            orderRemarks: tradeForm.tradeMemo,
            flag: tradeForm.tradeFlag,
            platefromOrderNum: tradeForm.platefromOrderNum,
            plateformAccountName: tradeForm.plateformAccountName
        })
    });
}

export const addTask = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/taskservice/add',
        method:'post',
        data:dialogForm
    })
}

export const queryTaskVo = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/taskservice/repeatreltask',
        method:'post',
        data:qs.stringify({
            b2cTasksId: dialogForm.b2cTaskId,
        })
    })
}

export const confirmTaskRelease = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/taskservice/confirmreleasetask',
        method:'post',
        data:qs.stringify({
            b2cTasksId: dialogForm.b2cTaskId,
        })
    })
}

export const cancelTaskRelease = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/taskservice/cancelreleasetask',
        method:'post',
        data:qs.stringify({
            b2cTasksId: dialogForm.b2cTaskId,
        })
    })
}

export const queryTaskClassMoneys = () => {
    return jwtServerInstance.request({
        url:'/taskservice/taskclassmoneys',
        method:'post'
    })
}

export const getTaskInfo = (queryform,pagination) =>{
    return jwtServerInstance.request({
        url:'/taskservice/query',
        method:'post',
        data:qs.stringify({
            b2cTasksId: queryform.taskId,
            taskType: queryform.taskType,
            shopInfo: queryform.shopInfo,
            status: queryform.status,
            startTime: queryform.timeRange?queryform.timeRange[0]:null,
            endTime: queryform.timeRange?queryform.timeRange[1]:null,
            goodUrl: queryform.goodUrl,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const getTaskDetail = (taskId) => {
    return jwtServerInstance.request({
        url:'/taskservice/detail',
        method:'post',
        data:qs.stringify({
            b2ctasksId: taskId
        })
    })
}

export const getTaskVoInfo = (taskId) =>{
    return jwtServerInstance.request({
        url:'/taskservice/querytaskinfo',
        method:'post',
        data:qs.stringify({
            b2cTasksId: taskId
        })
    })
}

export const addTaskDetailContent = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/taskservice/addtdcontent',
        method:'post',
        data:dialogForm
    })
}

export const addTaskExtraDetailContent = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/taskservice/addextracontent',
        method:'post',
        data:dialogForm
    })
}

export const updateTaskDetailContent = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/taskservice/updatetdcontent',
        method:'post',
        data:dialogForm
    })
}

export const getAdminTaskInfo = (queryform,pagination) =>{
    return jwtServerInstance.request({
        url:'/taskservice/queryadmintask',
        method:'post',
        data:qs.stringify({
            taskId: queryform.taskId,
            businessName: queryform.businessName,
            taskTitle: queryform.taskTitle,
            taskType: queryform.taskType,
            status: queryform.status,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}



export const updateTaskQuestion = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/taskservice/uptaskquestion',
        method:'post',
        data:qs.stringify({
            b2cTasksId: dialogForm.taskId,
            taskQuestion: dialogForm.taskQuestion,
            goodsAnswers: dialogForm.goodsAnswers,
        })
    })
}

export const queryTaskQuestion = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/taskservice/queryquestion',
        method:'post',
        data:qs.stringify({
            b2cTasksId: dialogForm.taskId
        })
    })
}

export const queryTaskOrder = (taskId) => {
    return jwtServerInstance.request({
        url:'/taskservice/querytaskorder',
        method:'post',
        data:qs.stringify({
            b2ctasksId: taskId
        })
    })
}


//新增打标
export const alitaobaoDbiao = (formData)=>{
    return jwtServerInstance.request({
        url:'/taskservice/taobaodabiao',
        method:'post',
        data:qs.stringify({
            goodId: formData.goodId,
            keyword: formData.keyword,
            nickName: formData.nickName
        })
    })
}

//新增验号
export const alitaobaoVerifynumber =(formData) =>{
    return jwtServerInstance.request({
        url:'/taskservice/verifynumber',
        method:'post',
        data:qs.stringify({
            taobaoAccount: formData.taobaoAccount
        })
    })
}

